import { ANNOUNCEMENT_VIEWS, type AnnouncementView } from '@asyagrup/group-hub-contracts';

/**
 * Duyurular ekranının sekmeleri: beş liste penceresi ve kategori sözlüğü.
 *
 * Sözlük eskiden kendi ekranıydı (`/duyurular/kategoriler`) ve menüde
 * Duyuruların hemen altında kendi satırı vardı; artık bu ekranın son sekmesi.
 * Bu dosya, adresin hangi sekmeyi açtığına karar veren TEK yer — Destek ve
 * Yenilikler'deki `destek-sekmesi.ts` ile aynı düzen. Saf bir modül, React yok:
 * sayfa, menü satırının yarıları (`nav.ts` → Roller ekranı ve ⌘K) ve arama
 * kutusunun kısayolu aynı adresi buradan alıyor.
 *
 * `categories` bir `AnnouncementView` DEĞİL ve olmamalı: pencereler sunucuya
 * `view` olarak gidiyor, sözlük ise başka bir uçtan okunuyor. Sözleşmedeki
 * listeye eklemek, sunucuya geçersiz bir `view` gönderebilen bir tip açardı.
 * Adresteki adı İngilizce, kardeşleri (`drafts`, `scheduled`…) gibi.
 */
export type DuyuruSekmesi = AnnouncementView | 'categories';

export const KATEGORI_SEKMESI = 'categories' as const;

/**
 * Sözlüğün adresi. Eski `/duyurular/kategoriler` buraya yönleniyor (App.tsx);
 * dizenin yazımı yer imlerine bağlı ve `duyuru-sekmesi.test.ts` onu kilitliyor.
 */
export const KATEGORILER_ADRESI = `/duyurular?sekme=${KATEGORI_SEKMESI}`;

/**
 * URL'den gelen sekme adı DOĞRULANIYOR.
 *
 * Elle yazılmış bir `?sekme=zamanlanmis`, ya da yayım yetkisi sonradan alınmış
 * birinin yer imi, aksi hâlde sunucuya geçersiz bir `view` gönderir ve ekran
 * 400 ile açılırdı. Yetkisi olmayan için tek geçerli pencere gelen kutusu.
 *
 * Kategori sekmesi de aynı kurala bağlı: eski `/duyurular/kategoriler` yer imi
 * buraya yönleniyor, ve `announcement.category_manage` taşımayan biri o adresle
 * gelirse boş ya da reddedilen bir sözlük değil, gelen kutusu görür.
 */
export function readTab(
  raw: string | null,
  canPublish: boolean,
  canManageCategories: boolean,
): DuyuruSekmesi {
  if (raw === KATEGORI_SEKMESI) return canManageCategories ? KATEGORI_SEKMESI : 'inbox';
  const found = ANNOUNCEMENT_VIEWS.find((v) => v === raw);
  if (!found || (found !== 'inbox' && !canPublish)) return 'inbox';
  return found;
}
